import { inject, Injectable } from '@angular/core';

import { CommandMapper } from '../core/utils/mappers/command.mapper';
import { ActionButtonModel } from '../models/core/action-button.model';
import { RelatedItemModel } from '../models/core/related-item.model';
import { ControllerService } from './controller.service';

@Injectable({
    providedIn: 'root'
})
export class ActionButtonsService {
    private readonly controllerService = inject(ControllerService);

    convert(items: RelatedItemModel[]): ActionButtonModel[] {
        if (!items || items.length < 1) {
            return [];
        }

        const existingItems = items.filter(i => CommandMapper.commands.findIndex(c => c.name === i.commandName) >= 0);

        return existingItems.map(item => {
            // Newing related item is required because JSON returns are not newed objects.
            // getCommand() inside withRelated() wouldn't work.
            const relatedItem = new RelatedItemModel().withItem(item);
            const btn = new ActionButtonModel().withRelated(relatedItem);
            btn.clickFunction = () => {
                if (!!btn.beforeClickFunction) {
                    btn.beforeClickFunction(btn);
                }

                if (relatedItem.getCommand()?.isRequest) {
                    btn.isLoading = true;

                    const sub = this.controllerService.requestFinished.subscribe(resp => {
                        btn.isLoading = false;

                        if (!!btn.responseAction) {
                            btn.responseAction(btn, item, resp, this.controllerService);
                        }

                        sub.unsubscribe();
                    });
                }

                this.controllerService.execute(item, item.data);
            };
            item.referencedButton = btn;

            return btn;
        });
    }
}
